import axios from 'axios'

// config
import baseUrl from '../config'

export const createPurchaseRequest = async data => {
  return await axios({
    withCredentials: true,
    method: 'post',
    url: `${baseUrl}/sef/purchase-requests`,
    data,
    config: { headers: { 'Content-Type': 'multipart/form-data' } }
  })
}

export const deletePurchaseRequest = async ({ purchaseRequestId }) => {
  return await axios.delete(`${baseUrl}/sef/purchase-requests/${purchaseRequestId}`, {
    withCredentials: true
  })
}

export const fetchPurchaseRequest = async id => {
  const response = await axios.get(`${baseUrl}/sef/purchase-requests/${id}`, {
    withCredentials: true
  })
  return response.data
}

export const fetchPurchaseRequests = async params => {
  const response = await axios.get(`${baseUrl}/sef/purchase-requests`, {
    withCredentials: true,
    params
  })

  return response.data
}

export const initiatePurchaseRequestPayment = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'post',
    url: `${baseUrl}/sef/purchase-request-payments`,
    data
  })

  return response.data
}

export const updatePurchaseRequest = async purchaseRequest => {
  const response = await axios({
    withCredentials: true,
    method: 'put',
    url: `${baseUrl}/sef/purchase-requests/${purchaseRequest.get('id')}`,
    data: purchaseRequest,
    config: { headers: { 'Content-Type': 'multipart/form-data' } }
  })

  return response.data
}
